export interface RealtimeEvent {
  type: string
  entity?: string
  id?: string
  payload?: Record<string, unknown>
  notification?: {
    id: string
    message: string
    link?: string
    is_read?: boolean
    is_seen?: boolean
    created_at?: string
  }
}

export interface RealtimeDecision {
  invalidate: ReadonlyArray<readonly unknown[]>
  authRevoked: boolean
  notification?: RealtimeEvent['notification']
}

export function routeRealtimeEvent(event: RealtimeEvent): RealtimeDecision {
  if (event.type === 'auth_revoked') return { invalidate: [], authRevoked: true }

  if (event.type === 'grading_complete') {
    // The ['results'] prefix owns every result list/detail query, including
    // the review page's ['results', 'detail', id] — one query family per
    // server resource (PRODUCT-CONTRACT query-key ownership; the legacy
    // ['result-review', id] key was dead and has been removed).
    return {
      invalidate: [
        ['results'],
        ['dashboard'],
        ...(event.id ? [['results', 'detail', event.id] as const] : []),
        // Only score_published events carry a notification; lifecycle_refresh
        // events must not touch the notification cache or synthesize one.
        ...(event.notification ? [['notifications'] as const] : []),
      ],
      authRevoked: false,
      notification: event.notification,
    }
  }

  if (event.entity === 'test') {
    return {
      invalidate: [['tests'], ...(event.id ? [['test', event.id] as const] : [])],
      authRevoked: false,
    }
  }

  if (event.entity === 'result') {
    return {
      invalidate: [['results'], ['dashboard'], ...(event.id ? [['results', 'detail', event.id] as const] : [])],
      authRevoked: false,
    }
  }

  return { invalidate: [], authRevoked: false }
}
